import {Redirect} from '../ui/redirect';

new Redirect('/collections', '/');
